import React from 'react';
import TestimonialsContent from '../../FunctionalComponents/Testimonials/TestimonialsContent.jsx';

const Testimonials = () => {
  return (
    <TestimonialsContent />
  )
}

export default Testimonials;